import styled from '@emotion/styled';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';

import CreateReportButton from './create-report-button';
import { useDashboardDataContext } from './dashboard/dashboard-context';
import { isUserProjectLeadOrOwner } from './right-panel';
import Spacer from '../base/spacer';
import UserNavigationMenu from '../settings/user-navigation-menu';

import { DesignToken } from '~/client/components/base/core';
import { useUserProfile } from '~/client/hooks/user-profile';
import * as GQL from '~/graphql/generated/client';
import {
  LeftNavMenu,
  LeftNavMenuItem,
  useLeftNavContext,
} from '~c/components/base/left-nav';
import { ProjectDisplayName } from '~c/components/project/project-name-left-nav';
import {
  aiDashboardUtils,
  functionalModelsRouteUtil,
  candidateModelsDetailsRouteUtil,
} from '~c/routes';

interface Props {
  className?: string;
}

const ModelDetailsLeftNavImpl: React.FC<Props> = ({ className }) => {
  const { matchRoute, navigateTo } =
    candidateModelsDetailsRouteUtil.useHelper();

  const dashboard = functionalModelsRouteUtil.useHelper();
  const aiDashboard = aiDashboardUtils.useHelper();
  const { project } = useDashboardDataContext();
  const { userProfile } = useUserProfile();

  // Check if user can manage settings
  const canManageSettings = isUserProjectLeadOrOwner(
    project as GQL.Project,
    userProfile?.email ?? ''
  );

  const { state } = useLeftNavContext();
  const { currentRoute } = state;

  const routePrefix = {
    [candidateModelsDetailsRouteUtil.routePrefix]:
      candidateModelsDetailsRouteUtil.routePrefix,
  };
  const isDataset = project?.projectType === GQL.ProjectType.Dataset;

  return (
    <LeftNavMenu
      className={className}
      name={routePrefix[currentRoute ?? '']}
      header={{
        showBackButton: true,
        onClick: () =>
          dashboard.navigateTo(isDataset ? 'DATASETS' : 'CANDIDATES'),
        // projectName: <FunctionModelName className={className} />,
      }}
    >
      <LeftNavMenuItem
        selected={
          matchRoute('CANDIDATE_DETAILS') || matchRoute('DATASET_DETAILS')
        }
        icon={DashboardOutlinedIcon}
        onClick={() =>
          navigateTo(isDataset ? 'DATASET_DETAILS' : 'CANDIDATE_DETAILS')
        }
      >
        <ProjectDisplayName />
      </LeftNavMenuItem>
      <LeftNavMenuItem
        selected={false}
        icon={PeopleIcon}
        onClick={() => aiDashboard.navigateTo('PROJECT_MEMBERS')}
      >
        Stakeholders
      </LeftNavMenuItem>
      {canManageSettings && (
        <LeftNavMenuItem
          selected={matchRoute('SETTINGS')}
          icon={SettingsIcon}
          onClick={() => navigateTo('SETTINGS')}
        >
          Settings
        </LeftNavMenuItem>
      )}
      <CreateReportButton />
      <Spacer className="grow" />
      <UserNavigationMenu />
    </LeftNavMenu>
  );
};

const ModelDetailsLeftNav = styled(ModelDetailsLeftNavImpl)`
  .grow {
    flex-grow: 1;
  }
  .userinfo {
    padding: 16px;
    text-transform: capitalize;
  }
  .task-menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .task-badge {
    background-color: ${DesignToken.status.danger};
    color: ${DesignToken.brand.primaryContrast};
    border-radius: 10px;
    padding: 2px 8px;
    font-size: 12px;
    margin-left: 8px;
    font-weight: 500;
  }

  .v2-header {
    margin-left: -10px;
  }
`;

export default ModelDetailsLeftNav;
